import { createFileRoute } from '@tanstack/react-router'
import { ScenariosListPage } from '../../../components/scenarios/ScenariosListPage'

export const Route = createFileRoute('/$org/remediation-scenarios/')({
  component: ScenariosListPage,
})
